import styled from 'styled-components';
import FreeCancelTick from '../assets/freeCancelTick.svg';

const FreeCancelTickIcon = styled(FreeCancelTick as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '3rem'};
  height: ${props => props.height || '4.3rem'};
  fill: ${props => props.fill};
  margin: ${props => props.margin || '-0.1rem'};
`;

export default FreeCancelTickIcon;
